import { Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { GlobalMessages, AppMessage } from '@Services/global-messages';

@Component({
    standalone: false,
    selector: 'sm-global-alerts',
    templateUrl: './sm-global-alerts.component.html',
    styleUrls: ['./sm-global-alerts.component.scss']
})
export class SmGlobalAlertsComponent implements OnInit {

    messages: AppMessage[];
    alerts: AppMessage[] = [];

    constructor(private service: GlobalMessages,
        private destroyRef: DestroyRef) { }

    ngOnInit() {
        this.service.values
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(
            messages => this.messages = messages
        );
        
        this.service.last
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(
            last => {
                if (last)
                    this.addMessage(last)
            }
        );
    }

    addMessage(message: AppMessage) {
        var self = this;
        this.alerts.push(message);
        if (message.alertDuration) {
            setTimeout(() => {
                self.closeAlert(message);
            }, message.alertDuration);
        }
    }

    closeAlert(alert: AppMessage) {
        const index: number = this.alerts?.indexOf(alert);
        this.alerts?.splice(index, 1);
    }

    performAction(alert: AppMessage) {
        alert?.action?.action();
        this.closeAlert(alert);
    }

}
